
const formValidation = {
    data(){
        return {
            errors: {},

        }
    },
    methods: {
        collectErrors(errors,translation_scope) {
            let toReturn = {}
            errors.forEach((error, index) => {
                const fieldRef = error.field
                const validations_keys = error.validations.map((v) => v.errorKey)

                if (!toReturn[fieldRef]) {
                    toReturn[fieldRef] = []
                }
                validations_keys.forEach((ek) => {
                    const er_label = this.$vuetify.t(`$vuetify.${translation_scope}.errors.${fieldRef}.${ek}`)
                    toReturn[fieldRef].push(er_label)

                })

            })
            return toReturn
        },
        getErrorForField(fieldName, errorsObj = null) {
                if (!errorsObj){
                    errorsObj = this.errors
                }
                if (errorsObj[fieldName]) {
                    return errorsObj[fieldName]
                } else {
                    return []
                }
        },
        resetErrorForField(fieldName,errorsObj=null){
                if (!errorsObj){
                    errorsObj = this.errors
                }
                if (errorsObj[fieldName]){
                    errorsObj[fieldName] = []
                }

        }
    }
}




export default formValidation